<template>
  <div>
    <el-card shadow="always">
      <h1>客户管理</h1>
      <el-button type="primary" @click="showAddDialog = true">添加客户</el-button>
      <el-table
        :data="customers"
        style="width: 100%"
        border
        stripe
        :default-sort="{ prop: 'id', order: 'descending' }"
      >
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="phone" label="电话"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="small" @click="editCustomer(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteCustomer(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      ></el-pagination>

      <!-- 添加客户弹窗 -->
      <el-dialog title="添加客户" v-model="showAddDialog">
        <el-form :model="newCustomer" :rules="rules" ref="addForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="newCustomer.name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="newCustomer.email"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="newCustomer.phone"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="newCustomer.address"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showAddDialog = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确认</el-button>
        </template>
      </el-dialog>

      <!-- 编辑客户弹窗 -->
      <el-dialog title="编辑客户" v-model="showEditDialog">
        <el-form :model="editingCustomer" :rules="rules" ref="editForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editingCustomer.name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="editingCustomer.email"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="editingCustomer.phone"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="editingCustomer.address"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showEditDialog = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">保存</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      customers: [],
      total: 0, // 总记录数
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页码
      newCustomer: { name: "", email: "", phone: "", address: "" },
      editingCustomer: null,
      showAddDialog: false,
      showEditDialog: false,
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 50, message: "姓名长度应在 2 到 50 个字符之间", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入有效的邮箱地址", trigger: ["blur", "change"] }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: "请输入有效的手机号码", trigger: "blur" }
        ],
        address: [
          { max: 200, message: "地址长度不能超过 200 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.fetchCustomers();
  },
  methods: {
    async fetchCustomers() {
      try {
        const res = await axios.get("/api/customers", {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        });
        this.customers = res.data.data; // 当前页的数据
        this.total = res.data.total; // 总记录数
      } catch (error) {
        console.error("获取客户列表失败:", error);
        ElMessage.error("获取客户列表失败");
      }
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1; // 切换每页条数时重置到第一页
      this.fetchCustomers();
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
      this.fetchCustomers();
    },
    editCustomer(customer) {
      this.editingCustomer = { ...customer };
      this.showEditDialog = true;
    },
   async submitAdd() {
      try {
        await this.$refs.addForm.validate();
        await axios.post(
              "/api/customers",
              this.newCustomer, // 请求体（客户数据）
              {
                headers: {
                  'Authorization': `Bearer ${this.$store.getters.token}`
                }
              }
            );
            this.showAddDialog = false;
            this.fetchCustomers();
            ElMessage.success("客户添加成功");
          } catch (error) {
            if (error.response && error.response.data.detail) {
              ElMessage.error(error.response.data.detail);
            } else {
              ElMessage.error("添加客户失败，请检查输入内容");
            }
            console.error("添加客户失败:", error);
          }
    },

    async submitEdit() {
      try {
        await this.$refs.editForm.validate();
        await axios.put(`/api/customers/${this.editingCustomer.id}`, this.editingCustomer);
        this.showEditDialog = false;
        this.fetchCustomers();
        ElMessage.success("客户编辑成功");
      } catch (error) {
        if (error.response && error.response.data.detail) {
          ElMessage.error(error.response.data.detail);
        } else {
          ElMessage.error("编辑客户失败，请检查输入内容");
        }
        console.error("编辑客户失败:", error);
      }
    },
    async deleteCustomer(id) {
      try {
        await axios.delete(`/api/customers/${id}`);
        this.fetchCustomers();
        ElMessage.success("客户删除成功");
      } catch (error) {
        ElMessage.error("删除客户失败");
        console.error("删除客户失败:", error);
      }
    }
  }
};
</script>

<style scoped>
/* 确保样式没有覆盖表头 */
.el-table th {
  background-color: #f0f2f5;
  color: #333;
}

/* 分页组件样式 */
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
